import React, { useEffect, useState } from "react";
import { Container, Row, Col, Pagination } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion";

// Image imports
import work1 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.18 PM.jpeg";
import work2 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.20 PM (1).jpeg";
import work3 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.20 PM.jpeg";
import work4 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.20 PM.jpeg";
import work5 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.21 PM (2).jpeg";
import work6 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.21 PM.jpeg";
import work7 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.22 PM.jpeg";
import work8 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.23 PM (1).jpeg";
import work9 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.23 PM.jpeg";
import work10 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.24 PM.jpeg";
import work11 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.25 PM (1).jpeg";
import work12 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.25 PM.jpeg";
import work13 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.29 PM.jpeg";
import work14 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.30 PM.jpeg";
import work15 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.31 PM.jpeg";
import work16 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.32 PM (1).jpeg";
import work17 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.32 PM.jpeg";
import work18 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.33 PM.jpeg";
import work19 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.35 PM.jpeg";
import work20 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.41 PM (1).jpeg";
import work22 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.42 PM (1).jpeg";
import work23 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.42 PM (2).jpeg";
import work24 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.42 PM.jpeg";
import work25 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.44 PM (1).jpeg";
import work26 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.43 PM.jpeg";
import work28 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.46 PM.jpeg";
import work29 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.48 PM.jpeg";
import work30 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.46 PM (2).jpeg";
import work31 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.49 PM.jpeg";
import work32 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.50 PM (1).jpeg";
import work33 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.50 PM (2).jpeg";
import work34 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.50 PM.jpeg";
import work35 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.51 PM (1).jpeg";
import work36 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.51 PM.jpeg";
import work37 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.52 PM (1).jpeg";
import work38 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.52 PM.jpeg";
import work39 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.53 PM (1).jpeg";
import work40 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.53 PM.jpeg";
import work41 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.54 PM (1).jpeg";
import work42 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.54 PM (2).jpeg";
import work43 from "../assets/images/works/WhatsApp Image 2025-01-07 at 7.28.54 PM.jpeg";

interface PortfolioData {
  image: string;
  groups: string[];
  title: string;
  category: string;
}

const portfolioData: PortfolioData[] = [
  {
    image: work1,
    groups: ["Architecture"],
    title: "The Usefulness",
    category: "Design",
  },
  {
    image: work2,
    groups: ["Electric"],
    title: "Nonsensical Content",
    category: "Painting",
  },
  {
    image: work3,
    groups: ["Electric"],
    title: "Prevents Patterns",
    category: "Corporate",
  },
  {
    image: work4,
    groups: ["Electric", "Painting"],
    title: "The Advantageous",
    category: "Graphics",
  },
  {
    image: work5,
    groups: ["Builder"],
    title: "Automatic recognition",
    category: "Architecture Design",
  },
  {
    image: work6,
    groups: ["Architecture", "Painting"],
    title: "Pre-press workflow",
    category: "Development",
  },
  {
    image: work7,
    groups: ["Painting"],
    title: "Another Item",
    category: "Graphics",
  },
  {
    image: work8,
    groups: ["Builder"],
    title: "More Content",
    category: "Painting",
  },
  {
    image: work9,
    groups: ["Electric"],
    title: "Some Text",
    category: "Development",
  },
  {
    image: work10,
    groups: ["Architecture"],
    title: "The Usefulness",
    category: "Design",
  },
  {
    image: work11,
    groups: ["Electric"],
    title: "Nonsensical Content",
    category: "Painting",
  },
  {
    image: work12,
    groups: ["Electric"],
    title: "Prevents Patterns",
    category: "Corporate",
  },
  {
    image: work13,
    groups: ["Electric", "Painting"],
    title: "The Advantageous",
    category: "Graphics",
  },
  {
    image: work14,
    groups: ["Builder"],
    title: "Automatic recognition",
    category: "Architecture Design",
  },
  {
    image: work15,
    groups: ["Architecture", "Painting"],
    title: "Pre-press workflow",
    category: "Development",
  },
  {
    image: work16,
    groups: ["Painting"],
    title: "Another Item",
    category: "Graphics",
  },
  {
    image: work17,
    groups: ["Builder"],
    title: "More Content",
    category: "Painting",
  },
  {
    image: work18,
    groups: ["Electric"],
    title: "Some Text",
    category: "Development",
  },
  {
    image: work19,
    groups: ["Architecture"],
    title: "The Usefulness",
    category: "Design",
  },
  {
    image: work20,
    groups: ["Electric"],
    title: "Nonsensical Content",
    category: "Painting",
  },
  {
    image: work22,
    groups: ["Electric"],
    title: "Prevents Patterns",
    category: "Corporate",
  },
  {
    image: work23,
    groups: ["Electric", "Painting"],
    title: "The Advantageous",
    category: "Graphics",
  },
  {
    image: work24,
    groups: ["Builder"],
    title: "Automatic recognition",
    category: "Architecture Design",
  },
  {
    image: work25,
    groups: ["Architecture", "Painting"],
    title: "Pre-press workflow",
    category: "Development",
  },
  {
    image: work26,
    groups: ["Painting"],
    title: "Another Item",
    category: "Graphics",
  },
  {
    image: work28,
    groups: ["Builder"],
    title: "More Content",
    category: "Painting",
  },
  {
    image: work29,
    groups: ["Electric"],
    title: "Some Text",
    category: "Development",
  },
  {
    image: work30,
    groups: ["Architecture"],
    title: "The Usefulness",
    category: "Design",
  },
  {
    image: work31,
    groups: ["Electric"],
    title: "Nonsensical Content",
    category: "Painting",
  },
  {
    image: work32,
    groups: ["Electric"],
    title: "Prevents Patterns",
    category: "Corporate",
  },
  {
    image: work33,
    groups: ["Electric", "Painting"],
    title: "The Advantageous",
    category: "Graphics",
  },
  {
    image: work34,
    groups: ["Builder"],
    title: "Automatic recognition",
    category: "Architecture Design",
  },
  {
    image: work35,
    groups: ["Architecture", "Painting"],
    title: "Pre-press workflow",
    category: "Development",
  },
  {
    image: work36,
    groups: ["Painting"],
    title: "Another Item",
    category: "Graphics",
  },
  {
    image: work37,
    groups: ["Builder"],
    title: "More Content",
    category: "Painting",
  },
  {
    image: work38,
    groups: ["Electric"],
    title: "Some Text",
    category: "Development",
  },
  {
    image: work39,
    groups: ["Builder"],
    title: "More Content",
    category: "Painting",
  },
  {
    image: work40,
    groups: ["Electric"],
    title: "Some Text",
    category: "Development",
  },
  {
    image: work41,
    groups: ["Electric"],
    title: "Some Text",
    category: "Development",
  },
  {
    image: work42,
    groups: ["Electric"],
    title: "Some Text",
    category: "Development",
  },
  {
    image: work43,
    groups: ["Electric"],
    title: "Some Text",
    category: "Development",
  },
];

const ITEMS_PER_PAGE = 6; // عدد العناصر في كل صفحة

const InteriorConstructionWork: React.FC = () => {
  const [filter, setFilter] = useState("All");
  const [currentPage, setCurrentPage] = useState(1); // الصفحة الحالية
  const { t } = useTranslation();

  const handleFilter = (group: string) => {
    setFilter(group);
    setCurrentPage(1); // إعادة الصفحة للأولى عند تغيير الفلتر
  };
    const [showOptions, setShowOptions] = useState(false);


  // تصفية البيانات
  const filteredData =
    filter === "All"
      ? portfolioData
      : portfolioData.filter((item) => item.groups.includes(filter));

  // حساب عدد الصفحات
  const totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE);

  // تحديد العناصر المعروضة بناءً على الصفحة الحالية
  const paginatedData = filteredData.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
    const handleCallClick = (phone: string) => {
    window.location.href = `tel:${phone}`;
  };

  const handleWhatsAppClick = (phone: string, message: string = "") => {
    // Encode the message to ensure it's URL-safe
    const encodedMessage = encodeURIComponent(message);

    // WhatsApp URL for web and app
    const whatsappWebUrl = `https://web.whatsapp.com/send?phone=${phone}&text=${encodedMessage}`;
    const whatsappAppUrl = `whatsapp://send?phone=${phone}&text=${encodedMessage}`;

    // Check if the user is on a mobile device
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    // Open the appropriate WhatsApp link
    const whatsappUrl = isMobile ? whatsappAppUrl : whatsappWebUrl;
    window.open(whatsappUrl, "_blank");
  };

  // تكوين الانيميشن للصور
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: {
      x: 50,
      opacity: 0,
    },
    visible: {
      x: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 12,
      },
    },
    exit: {
      x: -50,
      opacity: 0,
      transition: {
        duration: 0.3,
      },
    },
  };

  return (
    <React.Fragment>
      <section className="section portfolio business-portfolio" id="work">
        <Container>
          <Row className="justify-content-center">
            <Col lg={6}>
              <motion.div
                initial={{ y: -20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5 }}
                className="text-center"
              >
                <div className="text-center">
                  <h2
                    className="heading-title-title text-uppercase"
                    style={{
                      fontSize: "50px",
                      position: "relative",
                      display: "inline-block",
                    }}
                  >
                    {t("portfolio.recentProjects")}
                    <span
                      style={{
                        display: "block",
                        width: "100px",
                        height: "4px",
                        backgroundColor: "#000",
                        margin: "10px auto 0",
                      }}
                    ></span>
                  </h2>
                </div>
              </motion.div>
            </Col>
          </Row>
          <AnimatePresence mode="wait">
            <motion.div
              key={currentPage}
              variants={containerVariants}
              initial="hidden"
              animate="visible"
              exit="hidden"
            >
              <Row className="mt-4">
                {paginatedData.map((item, index) => (
                  <Col lg={4} md={6} sm={12} className="mb-4" key={index}>
                    <motion.div
                      variants={itemVariants}
                      className="relative overflow-hidden group"
                      whileHover={{ scale: 1.02 }}
                      transition={{ duration: 0.3 }}
                    >
                      <div
                        className="portfolio-item position-relative"
                        style={{ overflow: "hidden" }}
                      >
                        <Link
                          className="lightbox port d-block"
                          to="#"
                          title={item.title}
                        >
                          <img
                            className="w-100 portfolio-image"
                            src={item.image}
                            alt={item.title}
                            style={{ height: "300px", objectFit: "cover" }}
                          />
                        </Link>
                        <div>
                     <div className="whatsapp-icon text-center d-flex align-items-center justify-content-center flex-column">
  <p className="text-white fs-5 fw-bold">{t("portfolio.order")}</p>

  <motion.button
    whileHover={{ scale: 1.1 }}
    whileTap={{ scale: 0.95 }}
    className="bg-success text-white px-6 py-2 rounded"
    onClick={() => setShowOptions(!showOptions)}
  >
    {t("portfolio.contact")}
  </motion.button>

  {showOptions && (
    <div className="bg-white shadow-lg p-3 rounded mt-2">
      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        className="bg-success text-white px-6 py-2 rounded w-100 mb-2"
        onClick={() =>
          handleWhatsAppClick("+966510731221", "مرحبا بك")
        }
      >
        WhatsApp
      </motion.button>

      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        className="bg-primary text-white px-6 py-2 rounded w-100"
        onClick={() => handleCallClick("+966510731221")}
      >
        اتصل الآن
      </motion.button>
    </div>
  )}
</div>

                        </div>
                      </div>
                    </motion.div>
                  </Col>
                ))}
              </Row>
            </motion.div>
          </AnimatePresence>

          {/* التنقل بين الصفحات */}
          {totalPages > 1 && (
            <Row className="mt-4">
              <Col>
                <motion.div
                  className="flex justify-center items-center gap-3"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.3 }}
                >
                  <div className="d-flex justify-content-center gap-2">
                    {[...Array(totalPages)].map((_, index) => (
                      <motion.button
                        key={index}
                        onClick={() => handlePageChange(index + 1)}
                        className={`w-3 h-3 rounded-full ${
                          index + 1 === currentPage ? "bg-black" : "bg-gray-300"
                        }`}
                        whileHover={{ scale: 1.2 }}
                        whileTap={{ scale: 0.9 }}
                        initial={false}
                        animate={
                          index + 1 === currentPage
                            ? { scale: 1.2 }
                            : { scale: 1 }
                        }
                      />
                    ))}
                  </div>
                </motion.div>
              </Col>
            </Row>
          )}
        </Container>
      </section>
    </React.Fragment>
  );
};

export default InteriorConstructionWork;
